import { render, staticRenderFns } from "./TabButtons.vue?vue&type=template&id=e3e6d812&scoped=true"
import script from "./TabButtons.vue?vue&type=script&lang=js"
export * from "./TabButtons.vue?vue&type=script&lang=js"
import style0 from "./TabButtons.vue?vue&type=style&index=0&id=e3e6d812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e6d812",
  null
  
)

export default component.exports